/*
 * Created Date: Friday January 27th 2023
 * Author: Oskar Karnblad
 * License: Proprietary to Scaffcalc AB
 *
 * Copyright (c) 2023 Scaffcalc AB
 */
export enum DRAW_COMPONENT {
  BASECOLLARS = "baseCollars",
  BASEPLATES = "basePlates",
  CLOTHING = "clothings",
  COLANDERS = "colanders",
  CONSOLEDECKS = "consoleDecks",
  CONSOLERAILPOST = "consoleRailPost",
  CONSOLES = "consoles",
  COUPLER = "coupler",
  DECKS = "decks",
  DIAGONALBRACE = "diagonalBraces",
  DIAGONALBRACESX = "diagonalBracesX",
  DIAGONALBRACESZ = "diagonalBracesZ",
  ELEVATORCABLEGUIDES = "elevatorCableGuides",
  ELEVATORFIXBRACKETS = "elevatorFixBrackets",
  ELEVATORFIXCOUPLERS = "elevatorFixCouplers",
  ELEVATORFIXPIPES = "elevatorFixPipes",
  ELEVATORLANDINGCAMS = "elevatorLandingCams",
  ELEVATORLANDINGEQUIPMENTS = "elevatorLandingEquipments",
  ELEVATORMASTS = "elevatorMasts",
  ELEVATORPIPES = "elevatorPipes",
  ELEVATORS = "elevators",
  ELEVATORSLIDINGGATES = "elevatorSlidingGates",
  ELEVATORSWIVELCOUPLERS = "elevatorSwivelCouplers",
  ELEVATORTIEINBRACKETS = "elevatorTieInBrackets",
  FRAMES = "frames",
  FRAMESUPPORT = "frameSupport",
  GUARDRAIL = "guardRail",
  GUARDRAILSX = "guardRailsX",
  GUARDRAILSZ = "guardRailsZ",
  LEDGER = "ledger",
  LEDGESX = "ledgesX",
  LEDGESZ = "ledgesZ",
  LIFTOFFPREVENTER = "liftOffPreventer",
  LOCK = "lock",
  MESHPANEL = "messhPanel",
  PIPEANCHORS = "pipeAnchors",
  RAIL = "rail",
  RAILPOST = "railPost",
  RINGSCREW = "ringScrew",
  STAIRDECK = "stairDeck",
  STAIRFENCE = "stairFence",
  STAIRHATCH = "stairHatch",
  STAIRS = "stairs",
  STAIRWAYGUARDRAILPOSTS = "stairWayGuardRailPosts",
  STAIRWAYGUARDRAILS = "stairWayGuardRails",
  STAIRWAYGUARDRAILSWIDEINNER = "stairWayGuardRailsWideInner",
  STAIRWAYGUARDRAILSINNER = "stairWayGuardRailsInner",
  STAIRWAYS = "stairWays",
  STANDARDS = "standards",
  TOEBOARD = "toeBoard",
  TOEBOARDSX = "toeBoardsX",
  TOEBOARDSZ = "toeBoardsZ",
  TRUSSBEAMJOINT = "trussBeamJoint",
  TRUSSBEAMS = "trussBeams",
  VANCHORS = "vAnchors",
  SOLEBOARD = "soleBoard",
}

export enum DRAW_CAMERA {
  PERSPECTIVE = "perspective",
  ORTHOGRAPHIC = "orthographic",
}

export enum DRAW_RENDERMODE {
  BOX = "box",
  REAL = "real",
}

export enum DRAW_TOOL {
  RECTANGLE = "rectangle",
  CYLINDER = "cylinder",
  MEASURE = "measure",
  POLYGON = "polygon",
  MAP = "map",
  IFC = "ifc",
  BLUEPRINT = "blueprint",
}

export enum DRAW_ROOFMODE {
  MEASURE = "measure",
}

export enum DRAW_SCAFFOLDMODE {
  INIT = "init",
  ADD = "add",
  ADDONS = "addons",
  AUTO = "auto",
  MEASURE = "measure",
}

export enum DRAW_MODE {
  BLUEPRINT = "blueprint",
  HOUSE = "house",
  ROOF = "roof",
  SCAFFOLD = "scaffold",
}

export enum DRAW_SUBMODE {
  PRIMARY = "primary",
  SECONDARY = "secondary",
}

export enum DRAW_DIRECTION {
  POSX = "posX",
  NEGX = "negX",
  POSY = "posY",
  NEGY = "negY",
  POSZ = "posZ",
  NEGZ = "negZ",
}

export enum DRAW_TOOLMODE {
  MEASURE = "measure",
  DRAWING = "drawing",
  TRANSLATING = "translating",
  SCALING = "scaling",
  DELETE = "delete",
  ROTATING = "rotating",
}

export enum DRAW_SIDE {
  BOTTOM = "bottom",
  LEFT = "left",
  RIGHT = "right",
  TOP = "top",
}

export enum DRAW_ANCHOR_POINT {
  CENTER = "center",
  CORNER = "corner",
}

export enum DRAW_TRS_MODE {
  ADDBAY = "add",
  ANCHORS = "anchors",
  /** Add other when necessary */
}

export enum DRAW_DIAGONAL_PATTERNS {
  CROSSDIAGONAL = "crossDiagonal",
  INWARDDIAGONAL = "inwardDiagonal",
  OUTWARDDIAGONAL = "outwardDiagonal",
  EVERYOTHER = "everyOther",
  EVERYOTHERREVERSE = "everyOtherReverse",
}
